import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Washington State Portal": {
    parameters: {
      linkUrls: ["https://secureaccess.wa.gov/myAccess/saw/select.do"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "WA",
  },
};
